const customParams = {
  customCategories: [],
}

window.addEventListener('GA_ADD_TO_CART', event => {
  pushToDataLayer('add_to_cart_item_categories')
  transformElevarEvent('dl_add_to_cart')
})

document.addEventListener('DOMContentLoaded', () => {
  const isProductTemplate = document.body.classList.contains('template-product')

  if (!isProductTemplate) return

  pushToDataLayer('view_item_categories')
  transformElevarEvent('dl_view_item')
})

async function pushToDataLayer (event) {
  const customCategories = await getCustomCategories()

  if (!customCategories) return

  const customCategoriesArr = JSON.parse(customCategories)

  if (customCategoriesArr.length) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event,
      dlv: {
        item_custom_category2: customCategoriesArr[0],
        item_custom_category3: customCategoriesArr[1],
      },
    })
  }
}

async function transformElevarEvent (event) {
  const customCategories = await getCustomCategories()

  if (!customCategories) return

  window.ElevarTransformFn = item => {
    if (item.event === event) {
      const customCategoriesArr = JSON.parse(customCategories)
      const detailKey = event === 'dl_add_to_cart' ? 'add' : 'detail'

      customCategoriesArr.forEach((category, i) => {
        const index = i + 2
        const categoryKey = `item_category${index}`

        item.ecommerce[detailKey].products[0][categoryKey] = category
      })

      return { ...item }
    } else {
      return item
    }
  }
}

async function getCustomCategories () {
  let customCategories = customParams.customCategories

  if (!customCategories.length) {
    const handle = window.location.pathname.split('/').pop()
    const query = metafieldQuery('analytics', 'categories')

    customCategories = await fetchProductMetafield(handle, query)
  }

  return customCategories
}

async function fetchProductMetafield (handle, query) {
  const variables = { handle }
  let accessToken

  switch (window.Shopify.shop) {
    case 'victoria-beckham-uk.myshopify.com':
      accessToken = '168f99de7d723da47c230f9c10cf24cb'
      break
    case 'victoria-beckham-international.myshopify.com':
      accessToken = '31cc683cefe9da904e791acdc7ecca64'
      break
    case 'victoria-beckham-us.myshopify.com':
      accessToken = 'fbc6b806071953905a2b3f32ef9421ae'
      break
    default:
      console.error('No access token found - product metafield fetch failed')
      return
  }

  const response = await fetch(`https://${window.Shopify.shop}/api/2024-04/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': accessToken,
    },
    body: JSON.stringify({ query, variables }),
  })

  const data = await response.json()
  return data.data.productByHandle?.metafield?.value
}

function metafieldQuery (namespace, key) {
  return `
    query getProductMetafield($handle: String!) {
      productByHandle(handle: $handle) {
        id
        title
        metafield(namespace: "${namespace}", key: "${key}") {
          value
          type
        }
      }
    }
  `
}
